import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import store from '@/store'

export const useExportCenter = (options) => {
  const router = useRouter()
  const downloadRoute = computed(() => router.resolve({
    name: 'SheetExportCenter',
    query: options?.shopId ? { shopId: options.shopId } : {},
  }).href)

  const navigateToDownloadCenter = async () => {
    if (options?.shopId) {
      const success = await store.dispatch('auth/changeShop', {
        shopId: options.shopId,
        message: window.$message,
      })
      if (!success) return
    }
    router.push({ name: 'SheetExportCenter' })
  }

  const messageOptions = computed(() => {
    return {
      type: 'success',
      dangerouslyUseHTMLString: true,
      message: `<p>匯出任務已建立，請至<a class="underline" href="${downloadRoute.value}">下載中心</a>查看任務與下載匯出檔案</p>`,
      duration: 0,
      showClose: true,
    }
  })
  return {
    messageOptions,
    navigateToDownloadCenter,
  }
}
